import React from 'react';
import IMessageBox from './IMessageBox';
import * as style from './MessageBoxStyle.module.scss'

const MessageBox: React.FunctionComponent<IMessageBox> = (props) => {
  return (
    <div className={style.messageBox}>
      {props.children}
    </div>
  );
};

export default MessageBox;
